import { gql } from '@/utilities/gql';

export const HOLDING_FRAGMENT = gql(`
  fragment holdingFields on Holding @_unmask {
    id
    symbol
    companyId
    isAnalysisRestricted
    currencyISO
    analysis {
      value
      roiValue
      roi
    }
  }
`);

export const PORTFOLIOS_FRAGMENT = gql(
  `
  fragment portfolioFields on Portfolio @_unmask {
    id
    name
    createdAt
    currencyISO
    updatedAt
    type
    manualInputOption
    isAnalysisRestricted
    link {
      brokerageName
    }
    holdings {
      ...holdingFields
    }
  }
`,
  [HOLDING_FRAGMENT]
);
